import type { ButtonProps, TextFieldProps, FormControlProps } from '@mui/material';

export const BUTTON_VARIANTS = {
  primary: 'contained',
  secondary: 'outlined',
  tertiary: 'text',
} as const;

export const BUTTON_SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const INPUT_VARIANTS = {
  outlined: 'outlined',
  filled: 'filled',
  standard: 'standard',
} as const;

export const FORM_CONTROL_VARIANTS = {
  outlined: 'outlined',
  filled: 'filled',
  standard: 'standard',
} as const;

export const CHIP_VARIANTS = {
  filled: 'filled',
  outlined: 'outlined',
} as const;

export const BUTTON_COLORS = {
  primary: 'primary',
  secondary: 'secondary',
  error: 'error',
  success: 'success',
  info: 'info',
  warning: 'warning',
  inherit: 'inherit',
} as const;

export type ButtonVariant = (typeof BUTTON_VARIANTS)[keyof typeof BUTTON_VARIANTS];
export type ButtonSize = (typeof BUTTON_SIZES)[keyof typeof BUTTON_SIZES];
export type InputVariant = (typeof INPUT_VARIANTS)[keyof typeof INPUT_VARIANTS];
export type FormControlVariant = (typeof FORM_CONTROL_VARIANTS)[keyof typeof FORM_CONTROL_VARIANTS];
export type ButtonColor = (typeof BUTTON_COLORS)[keyof typeof BUTTON_COLORS];

export const DEFAULT_BUTTON_PROPS: Partial<ButtonProps> = {
  variant: BUTTON_VARIANTS.primary,
  size: BUTTON_SIZES.medium,
};

export const DEFAULT_TEXT_FIELD_PROPS: Partial<TextFieldProps> = {
  variant: INPUT_VARIANTS.outlined,
  size: BUTTON_SIZES.small,
  fullWidth: true,
};

export const DEFAULT_FORM_CONTROL_PROPS: Partial<FormControlProps> = {
  variant: FORM_CONTROL_VARIANTS.outlined,
  size: BUTTON_SIZES.small,
  fullWidth: true,
};
